import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'flow',
      type: 'select',
      label: '流向',
      placeholder: '请选择流向',
      clearable: true,
      options: [
        { title: '减积分', value: '0' },
        { title: '加积分', value: '1' }
      ]
    },
    {
      field: 'reason',
      type: 'input',
      label: '原因',
      placeholder: '请输入原因'
    }
  ]
}
